<div *ngIf="content">
    <span [innerHtml]="content"></span>
</div>